module.exports = __webpack_public_path__ + "media/images/feature-3-be1b8ba8.png";